import { logger } from '@ubeeqo/web-utils';

export const NAMESPACE = 'Cities';
export const FULL_NAMESPACE = `App/${NAMESPACE}`;

export const DEFAULT_STATE = {
  cities: [],
};

export const DEFAULT_STATUS = {
  IDLE: true,
  LOADED: false,
  ERROR: false,
};

export const state = {
  ...DEFAULT_STATE,
  STATUS: Object.assign({}, DEFAULT_STATUS),
};

export const GETTERS = {
  GET_CITY_BY_UUID: 'getCityByUuid',
};

export const getters = {
  [GETTERS.GET_CITY_BY_UUID](s) {
    return (uuid) => {
      if (s.cities) {
        return s.cities.find(i => i.uuid === uuid);
      }
      return undefined;
    };
  },
};

export const MUTATIONS = {
  RESET_STATE: 'resetState',
  SET_CITIES: 'setCities',
  SET_STATUS: 'setStatus',
};

export const mutations = {
  // eslint-disable-next-line no-unused-vars
  [MUTATIONS.RESET_STATE](state) {
    // eslint-disable-next-line no-param-reassign
    state = { ...DEFAULT_STATE };
  },
  [MUTATIONS.SET_CITIES](state, payload) {
    state.cities = payload;
  },
  [MUTATIONS.SET_STATUS](state, value) {
    const states = Object.keys(state.STATUS);
    if (states.indexOf(value) > -1) {
      states.forEach((key) => {
        state.STATUS[key] = (key === value);
      });
    }
  },
};

export const ACTIONS = {
  FETCH_CITIES: 'fetchCities',
};

export const actions = {
  [ACTIONS.FETCH_CITIES]({ commit, rootState }) {
    const api = rootState.Setup.apiInstance;

    api.getCities()
      .then((response) => {
        commit(MUTATIONS.SET_CITIES, response.data);
        commit(MUTATIONS.SET_STATUS, 'LOADED');
      })
      .catch((error) => {
        logger.error('CitiesModule.js', error);
        commit(MUTATIONS.SET_STATUS, 'ERROR');
      });
  },
};

export const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
